/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { StatusStats } from '../../api/initiative-stats';

export enum MessageType {
  Survey = 'survey',
  BulkSurvey = 'bulkSurvey',
  Question = 'question',
  User = 'user',
}

export enum MessageFormField {
  UserIds = 'userIds',
  ContributorIds = 'contributorIds',
  VerifierIds = 'verifierIds',
  Subject = 'subject',
  Message = 'message',
  SendByEmail = 'sendByEmail',
}

export interface MessageFormFields {
  [MessageFormField.UserIds]: string[];
  [MessageFormField.ContributorIds]: string[];
  [MessageFormField.VerifierIds]: string[];
  [MessageFormField.Subject]: string;
  [MessageFormField.Message]: string;
  [MessageFormField.SendByEmail]: boolean;
  surveyId?: string;
  utrvId?: string;
};

export type OnChangeInterface = (property: string) => (value: string | boolean | string[]) => void;

export interface MessageFormProps {
  form: MessageFormFields;
  onChange: OnChangeInterface;
}

export interface MessagePayload extends MessageFormFields {
  type: MessageType;
}

export interface MessageResponse {
}

export type QuestionStatusStats = keyof StatusStats | 'all';
export interface StatusOption {
  value: QuestionStatusStats,
  label: JSX.Element,
}

export interface RequesterMessageFormFields {
  [MessageFormField.Subject]: string;
  [MessageFormField.Message]: string;
  [MessageFormField.SendByEmail]: boolean;
};
